export default __webpack_public_path__ + "a63ce94f5f74630cb299b6855923c18c.png";